<template>
  <gg-select
    dense
    outlined
    :label="label"
    v-model="selected_service"
    :items="domains"
    item-value="id"
    hide-details
    @change="switchService"
  >
    <template slot="selection" slot-scope="{ item }">
      {{ item.groupname }} - {{ item.domain }}
    </template>
    <template slot="item" slot-scope="{ item }">
      {{ item.groupname }} - {{ item.domain }}
    </template>
  </gg-select>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'HostingSwitch',
  data: () => ({
    selected_service: '',
    show_groups: ['Shared Hosting', 'Reseller Hosting', 'Virtual Private Server', 'Dedicated Server'],
    domains: []
  }),
  computed: {
    ...mapGetters(['hosting', 'services', 'servicegroups']),
    label () {
      return this.$route.meta.parent === 'hosting_reseller' ? `Reseller Dashboard for ${this.hosting.domain}` : 'Currently Managing:'
    }
  },
  methods: {
    ...mapActions(['navigateTo', 'reportSuccess']),
    parseDomains () {
      this.domains = []

      this.services.forEach(item => {
        if (this.show_groups.indexOf(item.groupname) !== -1) {
          this.domains.push(item)
        }
      })

      this.domains.sort((a, b) => a.groupname.localeCompare(b.groupname))
    },
    switchService () {
      this.$nextTick(() => {
        this.navigateTo(this.selected_service)
        this.reportSuccess(`Switching to ${this.hosting.domain} service...`)
      })
    }
  },
  created () {
    this.parseDomains()
    this.selected_service = this.hosting.id
  },
  watch: {
    services () {
      this.parseDomains()
    }
  }
}
</script>
